import { TracInviteMetadata } from '../types/trac-invite-metadata';

export const getInviterName = (metadata: TracInviteMetadata): string => {
  if ('fullName' in metadata.inviter) {
    return metadata.inviter.fullName;
  }

  if ('name' in metadata.inviter) {
    return metadata.inviter.name;
  }

  return '';
}